import {Component, OnInit} from '@angular/core';
import {IntelligenceData} from '../../../models/intelligence-data.interface';
import {IntelligenceService} from '../../../services/intelligence.service';
import {IntelligenceSearchInterface} from '../../../models/intelligence-search.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {buildQueryParams, getFiltersFromQueryParams} from '../../../utils/filters-utils';

@Component({
  selector: 'app-retail-vs-municipalities-vs-other',
  templateUrl: './retail-vs-municipalities-vs-other.component.html',
  styleUrls: ['./retail-vs-municipalities-vs-other.component.scss']
})
export class RetailVsMunicipalitiesVsOtherComponent implements OnInit {

  text = 'Retail vs Municipalities vs Other';
  subtitle = '';
  years!: number[];
  data!: [IntelligenceData[]];

  constructor(private readonly intelligenceService: IntelligenceService,
              private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      const search = getFiltersFromQueryParams(params);

      this.intelligenceService.getYears().subscribe(data => {
        this.years = data;
        if (data.length > 0) {
          if (!search.year) {
            search.year = data[0];
          }
          this.intelligenceService.getRetailVsMunicipalitiesVsOther(search).subscribe(response => {
            this.data = response;
            this.subtitle = search.year.toString();
          });
        }
      });
    });
  }

  searchData(event: IntelligenceSearchInterface): void {
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: buildQueryParams(event)});
  }

}
